module.exports = __webpack_public_path__ + "img/advisory1.bdd8796d.svg";